import React from "react";
import {useFormik} from "formik";

import {useFeedbackTools} from "../../../../components/FeedbackTools";
import {ResponsiveStepperDialog} from "../../../../components/ResponsiveStepperDialog";
import {useAccommodationsPage} from "../../AccommodationContext";
import {useHome} from "../HomeContext";
import {useHomeAction} from "../HomeActionContext";
import StepBeds from "./StepBeds";
import StepInfo from "./StepInfo";
import {stepBedsSchema, stepInfoSchema} from "./apartmentValidationSchema";


const steps = ['Posti letto', 'Infomazioni'];
const stepValidations = [stepBedsSchema, stepInfoSchema];

const FormCreateApartment = () => {
    const {createApartment} = useHome();
    const {formCreateApartment, handleApartmentSelection} = useHomeAction();
    const {apartmentTypologies, apartmentCategories} = useAccommodationsPage();

    const [isSaving, setIsSaving] = React.useState(false);
    const [activeStep, setActiveStep] = React.useState(0);
    const isLastStep = activeStep === steps.length - 1;
    const {showErrorNotification, showSuccessNotification} = useFeedbackTools();

    const formik = useFormik({
        initialValues: {
            name: "",
            beds: 2,
            sofaBeds: 0,
            extraBeds: 0,
            mq: 50,
            numberOfBathroom: 1,
            apartmentTypologyId: apartmentTypologies.length > 0 ? apartmentTypologies[0].id : 0,
            apartmentCategoryId: apartmentCategories.length > 0 ? apartmentCategories[0].id : 0,
        },
        validationSchema: stepValidations[activeStep],
        validateOnMount: true,

        onSubmit: async (values, actions) => {
            if (isLastStep) {
                setIsSaving(true);
                try {
                    const apartment = await createApartment(values);
                    showSuccessNotification('Appartamento creato');
                    formCreateApartment.close();
                    handleApartmentSelection(apartment.id);
                } catch (e) {
                    showErrorNotification(e);
                    setIsSaving(false);
                }
            }
            else {
                setActiveStep(activeStep + 1);
                actions.setTouched({});
                actions.setSubmitting(false);
            }
        },
    });

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const getStepContent = () => {
        switch (activeStep) {
            case 0:
                return <StepBeds formik={formik}/>;
            case 1:
                return <StepInfo formik={formik}/>;
            default:
                throw new Error('Unknown step');
        }
    };

    const disableSave = Object.keys(formik.errors).some(x => formik.touched[x]);

    return <ResponsiveStepperDialog title="Nuovo appartamento"
                                    isOpen={true}
                                    steps={steps}
                                    activeStep={activeStep}
                                    isSaving={isSaving}
                                    enableSubmit={!disableSave}
                                    onClose={formCreateApartment.close}
                                    onBack={handleBack}
                                    onSubmit={formik.handleSubmit}
                                    disableBackdropClose
                                    noValidate
                                    >
        {getStepContent()}
    </ResponsiveStepperDialog>
}

export default FormCreateApartment;